import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import ViewerDocument from '../../../../shared/components/ViewerDocument'
import { useAlert } from '../../../../shared/components/Alert'
import useMultiCalculoClient from '../../../../clients/MultiCalculoClient/useMulticalculoClient'
import { DOCUMENT_TYPE } from '../../../../shared/constants/MultiCalculo'

const PolicyViewer = () => {
  const multiCalculoClient = useMultiCalculoClient()
  const { proposalUniqueId, insuranceUniqueId, policyUniqueId } = useParams()
  const { addMsgDanger } = useAlert()
  const navigate = useNavigate()
  const [documentData, setDocumentData] = useState('')

  useEffect(() => {
    if (!proposalUniqueId || !insuranceUniqueId) {
      addMsgDanger({
        title: 'Documento indisponível',
        message: 'Identificadores do documento não informados.',
        action: () => navigate('/multicalculo/solicitacoes'),
      })
      return
    }

    multiCalculoClient()
      .downloadDocumentByInsurance({
        proposalUniqueId,
        insuranceUniqueId,
        policyUniqueId,
        documentType: DOCUMENT_TYPE.POLICY,
        base64: true,
      })
      .then((response) => {
        setDocumentData(response?.data ?? response)
      })
      .catch(() => {
        addMsgDanger({
          title: 'Não foi possível carregar a apólice.',
          message: 'Tente novamente mais tarde ou contate o suporte.',
          action: () => navigate('/multicalculo/solicitacoes'),
        })
      })
  }, [
    proposalUniqueId,
    insuranceUniqueId,
    policyUniqueId,
    multiCalculoClient,
    addMsgDanger,
    navigate,
  ])

  if (!documentData) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Typography variant="body1">Carregando apólice…</Typography>
      </Box>
    )
  }

  return <ViewerDocument documentBase64={documentData} />
}

export default PolicyViewer
